import { render, staticRenderFns } from "./AddNiceCase.vue?vue&type=template&id=7cf50a7c&scoped=true&"
import script from "./AddNiceCase.vue?vue&type=script&lang=js&"
export * from "./AddNiceCase.vue?vue&type=script&lang=js&"
import style0 from "./AddNiceCase.vue?vue&type=style&index=0&id=7cf50a7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf50a7c",
  null
  
)

export default component.exports